export enum SyncMeetingsModalButtons {
  SKIP = 'Skip',
  FINISH = 'Finish',
}
